











import Vue from 'vue';
import { buildTypeDialog } from './BuildType';


export default Vue.extend({
  data: () => ({
    data: buildTypeDialog,
  }),
});
